import {api} from '@/http'

// 是否已有简历
const isHasResume = (callback, back) => {
  api('/api/resume', 'get', {page: 1, size: 1}, callback, back)
}

// 简历列表
const getMyResumeList = (data, callback, back) => {
  api('/api/resume', 'get', data, callback, back)
}

// 简历新增
const addResume = (data, callback, back) => {
  api('/api/resume', 'post', data, callback, back)
}

// 简历状态切换
const toggleResumeStatus = (id, callback) => {
  api('/api/resume/' + id + '/toggle', 'post', '', callback)
}

// 简历删除
const resumeDel = (id, callback) => {
  api('/api/resume/' + id, 'del', '', callback)
}

// 简历信息
const resumeDesc = (id, callback) => {
  api('/api/resume/' + id, 'get', '', callback)
}

// 简历刷新
const resumeRefresh = (id, callback) => {
  api('/api/resume/' + id + '/flush', 'post', '', callback)
}

// 简历名称修改
const resumeNameEdit = (id, data, callback) => {
  api('/api/resume/' + id + '/edit_name', 'post', data, callback)
}

// 简历头像修改
const resumePortraitEdit = (id, data, callback) => {
  api('/api/resume/' + id + '/base/edit_portrait', 'post', data, callback)
}

// 简历基本信息
const baseResumeGet = (id, callback) => {
  api('/api/resume/' + id + '/base', 'get', '', callback)
}

// 简历基本信息修改
const baseEditForm = (id, data, callback) => {
  api('/api/resume/' + id + '/base', 'put', data, callback)
}

// 简历求职意向
const positionResumeGet = (id, callback) => {
  api('/api/resume/' + id + '/intention', 'get', '', callback)
}

// 简历求职意向修改
const positionEditForm = (id, data, callback) => {
  api('/api/resume/' + id + '/intention', 'put', data, callback)
}

// 简历自我评价修改
const evaluateEditForm = (id, data, callback) => {
  api('/api/resume/' + id + '/self_evaluation', 'put', data, callback)
}

// 简历工作经历列表
const workFormGet = (id, callback) => {
  api('/api/resume/' + id + '/experience', 'get', '', callback)
}

// 简历工作经历修改
const workFormEdit = (id, data, callback) => {
  api('/api/resume/experience/' + id, 'put', data, callback)
}

// 简历工作经历添加
const workFormAdd = (id, data, callback) => {
  api('/api/resume/' + id + '/experience', 'post', data, callback)
}

// 简历工作经历删除
const workFormDel = (id, callback) => {
  api('/api/resume/experience/' + id, 'del', '', callback)
}

// 简历项目经验列表
const projectFormGet = (id, callback) => {
  api('/api/resume/' + id + '/project', 'get', '', callback)
}

// 简历项目经验修改
const projectFormEdit = (id, data, callback) => {
  api('/api/resume/project/' + id, 'put', data, callback)
}

// 简历项目经验添加
const projectFormAdd = (id, data, callback) => {
  api('/api/resume/' + id + '/project', 'post', data, callback)
}

// 简历项目经验删除
const projectFormDel = (id, callback) => {
  api('/api/resume/project/' + id, 'del', '', callback)
}

// 简历教育经历列表
const educationFormGet = (id, callback) => {
  api('/api/resume/' + id + '/education', 'get', '', callback)
}

// 简历教育经历修改
const educationFormEdit = (id, data, callback) => {
  api('/api/resume/education/' + id, 'put', data, callback)
}

// 简历教育经历添加
const educationFormAdd = (id, data, callback) => {
  api('/api/resume/' + id + '/education', 'post', data, callback)
}

// 简历教育经历删除
const educationFormDel = (id, callback) => {
  api('/api/resume/education/' + id, 'del', '', callback)
}

// 简历培训经历列表
const trainFormGet = (id, callback) => {
  api('/api/resume/' + id + '/train', 'get', '', callback)
}

// 简历培训经历修改
const trainFormEdit = (id, data, callback) => {
  api('/api/resume/train/' + id, 'put', data, callback)
}

// 简历培训经历添加
const trainFormAdd = (id, data, callback) => {
  api('/api/resume/' + id + '/train', 'post', data, callback)
}

// 简历培训经历删除
const trainFormDel = (id, callback) => {
  api('/api/resume/train/' + id, 'del', '', callback)
}

// 简历职业技能列表
const skillFormGet = (id, callback) => {
  api('/api/resume/' + id + '/skill', 'get', '', callback)
}

// 简历职业技能修改
const skillFormEdit = (id, data, callback) => {
  api('/api/resume/skill/' + id, 'put', data, callback)
}

// 简历职业技能添加
const skillFormAdd = (id, data, callback) => {
  api('/api/resume/' + id + '/skill', 'post', data, callback)
}

// 简历职业技能删除
const skillFormDel = (id, callback) => {
  api('/api/resume/skill/' + id, 'del', '', callback)
}

// 简历模版列表
const getResumeTemList = (callback) => {
  api('/api/resume/template', 'get', {page: 1, size: 999}, callback)
}

// 简历下载
const resumeDownload = (id, data, callback) => {
  api('/api/resume/' + id + '/download', 'downLoad', data, callback)
}

// 应届生学校摘取
const freshGraduate = (type, callback) => {
  api('/api/fresh_graduate_school?type=' + type, 'get', '', callback)
}

export default {
  freshGraduate,
  getResumeTemList,
  resumeDownload,
  isHasResume,
  getMyResumeList,
  addResume,
  toggleResumeStatus,
  resumeDel,
  resumeDesc,
  resumeRefresh,
  resumeNameEdit,
  resumePortraitEdit,
  baseResumeGet,
  baseEditForm,
  positionResumeGet,
  positionEditForm,
  evaluateEditForm,
  workFormGet,
  workFormEdit,
  workFormAdd,
  workFormDel,
  projectFormGet,
  projectFormAdd,
  projectFormEdit,
  projectFormDel,
  educationFormGet,
  educationFormDel,
  educationFormEdit,
  educationFormAdd,
  trainFormGet,
  trainFormAdd,
  trainFormDel,
  trainFormEdit,
  skillFormGet,
  skillFormAdd,
  skillFormEdit,
  skillFormDel
}



// WEBPACK FOOTER //
// ./src/api/resume/index.js